import PropTypes from "prop-types";
import { createContext, useState } from "react";
import * as loginService from "../services/login-service";

const Context = createContext({});

export function AuthContextProvider({ children }) {
    const token = window.localStorage.getItem("accessToken");
    const [authState, setAuthState] = useState({
        token,
        user: null,
        isChecking: token != null,
    });

    if (token != null && authState.user == null) {
        // Cerrar sesión del usuario cuando el token ha expirado
        loginService
            .checkAuthStatus()
            .then((response) => {
                // Si el token ha expirado, entonces limpiar la variable accessToken del localStorage
                if (!response.status) {
                    window.localStorage.removeItem("accessToken");
                }

                setAuthState({
                    token: !response.status ? null : token,
                    user: !response.status ? null : response.data,
                    isChecking: false,
                });
            })
            .catch(() => {
                window.localStorage.removeItem("accessToken");
                setAuthState({ token: null, user: null, isChecking: false });
            });
    }

    return (
        <Context.Provider value={{ authState, setAuthState }}>
            {children}
        </Context.Provider>
    );
}

AuthContextProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};

export default Context;
